import type { StateSchema } from '@/app/providers/storeProvider';

export const getEmailCodeResendAvailable = (state: StateSchema) =>
    state.resendEmailCode?.availableToResendIn === 0;
